<template>
  <div class="newsletter-wrapper">
    <form @submit.prevent="submit" novalidate class="newsletter-form" :class="{ 'has-error': v$.email.$error }">
      <input type="email" v-model.lazy="v$.email.$model" :placeholder="placeholder" />

      <button type="submit" :class="{ loading: loading }">
        <svg v-if="!buttonText" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.169 17.169">
          <path d="M7.034,0,5.865,1.168,9.62,4.923H0V6.575H9.62L5.865,10.33,7.034,11.5l5.749-5.749Z" transform="translate(8.131 0) rotate(45)" fill="#fff" />
        </svg>

        <div v-else class="text">
          <span>{{ buttonText }}</span>
        </div>

        <span class="newsletter-loader"></span>
      </button>
    </form>

    <div v-if="message" class="newsletter-response success" :class="{ 'success': success, 'error': !success }">{{ message }}</div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { email, required } from "@vuelidate/validators";
import axios from "axios";

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "please enter your email",
      required: false,
    },
    buttonText: {
      type: String,
      default: null,
      required: false,
    },
    loaderColor: {
      type: String,
      default: null,
      required: false,
    }
  },
  validations() {
    let validations = {
      email: {
        required,
        email
      },
    };

    return validations;
  },
  data() {
    return {
      v$: useVuelidate(),
      email: null,
      message: null,
      loading: false,
      success: null,
    };
  },
  methods: {
    submit() {
      const self = this;

      this.v$.$touch();

      if (!this.v$.$invalid) {
        this.message = null;
        this.loading = true;

        axios.defaults.headers.common = {
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-TOKEN": window.Laravel.csrfToken,
        };

        axios
          .post(self.action, {
            email: self.email
          })
          .then(function (response) {
            self.message = "You have subscribed!";
            self.loading = false;
            self.success = true;
          })
          .catch(function (error) {
            self.message = "there was a problem!";
            self.loading = false;
            self.success = true;
            
            setTimeout(() => {
              self.message = null;
              self.success = null;
              self.email = null;
              self.v$.$reset();
            }, 5000);
          });

      } else {
        this.success = false;
        this.message = 'This is not an email'

        setTimeout(() => {
          this.success = null;
          this.message = null;
        }, 2000);
      }
    },
  }
};
</script>

<style lang="scss">
.newsletter-wrapper {
  position: relative;
  width: 230px;
}

@keyframes newsletterLoad {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.newsletter-form {
  position: relative;

  input {
    width: 100%;
    border: none;
    outline: none;
    border-bottom: 1px solid #000;
    font-size: 8px;
    letter-spacing: 0.02rem;
    padding: 8px 10px;

    &::-webkit-input-placeholder {
      overflow: visible;
      font-size: 8px;
      color: rgba(#000, 0.5);
      letter-spacing: 0.02rem;
    }

    &::-moz-placeholder {
      overflow: visible;
      font-size: 8px;
      color: rgba(#000, 0.5);
      letter-spacing: 0.02rem;
    }

    &:-ms-input-placeholder {
      overflow: visible;
      font-size: 8px;
      color: rgba(#000, 0.5);
      letter-spacing: 0.02rem;
    }

    &:-moz-placeholder {
      overflow: visible;
      font-size: 8px;
      color: rgba(#000, 0.5);
      letter-spacing: 0.02rem;
    }
  }

  button {
    position: absolute;
    left: 100%;
    bottom: 0;
    font-size: 12px;
    color: #000;
    padding: 5px 5px;
    transition: opacity 250ms ease-in-out;

    .newsletter-loader {
      opacity: 0;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) translateZ(0);
      border-radius: 50%;
      width: 20px;
      height: 20px;
      border-top: 1px solid rgba(#000, 1);
      border-right: 1px solid rgba(#000, 1);
      border-bottom: 1px solid rgba(#000, 1);
      border-left: 1px solid #ca9141;
      animation: newsletterLoad 1.1s infinite linear;

      &::before {
        border-radius: 50%;
        width: 10em;
        height: 10em;
      }
    }

    &.loading {
      span {
        opacity: 0;
      }

      .newsletter-loader {
        opacity: 1;
      }
    }

    &:hover {
      opacity: 0.5;
    }
  }
}

.newsletter-response {
  position: absolute;
  top: 100%;
  left: 0;
  padding: 2px 10px;
  font-size: 9px;
  letter-spacing: 0.02rem;
  min-width: 100%;

  &.success {
    background-color: #a9f216;
    color: #000;
  }

  &.error {
    background-color: #ff0008;
    color: #fff;
  }
}
</style>